import { Capacitor } from '@capacitor/core'

export interface GeoPosition {
  lat: number
  lng: number
}

export async function requestAndGetLocation(): Promise<GeoPosition> {
  if (Capacitor.isNativePlatform()) {
    // Use Capacitor plugin on Android — properly triggers the system permission dialog
    const { Geolocation } = await import('@capacitor/geolocation')
    await Geolocation.requestPermissions()
    const pos = await Geolocation.getCurrentPosition({ timeout: 10000, enableHighAccuracy: true })
    return { lat: pos.coords.latitude, lng: pos.coords.longitude }
  }

  // Web fallback
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      pos => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      reject,
      { timeout: 10000, enableHighAccuracy: true }
    )
  })
}
